/* eslint-disable no-use-before-define */
/* eslint-disable springload/react/prop-types */

import 'url-search-params-polyfill';
// eslint-disable-next-line springload/import/extensions
import { h, render } from 'preact';
import SearchPage from './SearchPage';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

function initAlgoliaSearch() {
    loadSearchIfRequired();
    document.addEventListener('pjax:complete', loadSearchIfRequired);
}

function loadSearchIfRequired() {
    const rootNode = document.querySelector('[data-search-results]');
    const algoliaResults = document.querySelector('[data-search-results-list]');
    if (rootNode && !algoliaResults) loadPreactAlgoliaPage(rootNode);
}

function loadPreactAlgoliaPage(rootNode) {
    const root = render(<SearchPage />, rootNode);
    const unmountListener = document.addEventListener(
        'pjax:send',
        unmountPreact,
    );
    function unmountPreact() {
        render(null, rootNode, root); // unmount preact
        document.removeEventListener('pjax:send', unmountListener);
    }
}

export default initAlgoliaSearch;
